import Color from '@base/features/game/model/color';
import Sizes from './sizes';

/**
 * Возвращает позиции для всех "линий" на игровой доске
 * @return [{x},{y}] массив значений x,y, индекс элемента равен номеру линии
 */
export function getPositionsForLines(myColor: Color, gameSizes: Sizes, myHomeIsOnLeftPref: boolean) {
  const xLinesCount = 13;
  const offsetFromLeft = gameSizes.getCanvasSize().width / 30; // left board border offset
  const offsetFromRight = gameSizes.getCanvasSize().width / 9.059; // right border offset
  const offsetFromTop = gameSizes.getCanvasSize().height / 31; // top board border offset, same as bottom border offset
  // const stepBetweenLines = imageProvider.gameSizes.getCanvasSize().width / 40;
  const canvasWidth = gameSizes.getCanvasSize().width;
  const width = gameSizes.getCanvasSize().width - offsetFromLeft - offsetFromRight;
  const height = gameSizes.getCanvasSize().height - offsetFromTop * 2;
  const lineHeight = gameSizes.getLineSize().height;
  const lineWidth = gameSizes.getLineSize().width;

  const stepX = width / xLinesCount;
  // let stepY = height / yLinesCount;

  // let centerX = width / 2;

  const topLinesY = lineHeight / 2;
  const bottomLinesY = height - lineHeight / 2;

  let currentY;
  let currentX;

  const dropZoneOffset = lineWidth / 1.2;
  const result = [];
  if (myColor === Color.White) {
    result.push({
      x: canvasWidth - dropZoneOffset,
      y: height - lineHeight / 2,
    }); // 0
    for (let i = 1; i <= 12; i++) {
      let space = 0;
      if (i > 6) {
        space = 0.96;
      }
      currentX = canvasWidth - offsetFromRight - (i + space) * stepX + stepX / 2.29;
      currentY = bottomLinesY;
      result.push({ x: currentX, y: currentY });
    }

    for (let i = 13; i < 25; i++) {
      let space = 0;
      if (i > 18) {
        space = 0.97;
      }
      currentX = (i - 13 + space) * stepX + offsetFromLeft + stepX / 2.1;
      currentY = topLinesY;
      result.push({ x: currentX, y: currentY });
    }

    result.push({ x: canvasWidth - dropZoneOffset, y: lineHeight / 2 }); // 25

    result.push({
      x: (canvasWidth - offsetFromRight) / 2 + offsetFromLeft / 2,
      y: height - topLinesY * 1.6,
    }); // 26
    result.push({
      x: (canvasWidth - offsetFromRight) / 2 + offsetFromLeft / 2,
      y: topLinesY * 1.6,
    }); // 27
  } else if (myColor === Color.Black && myHomeIsOnLeftPref) {
    // here the board is rotated 180 degree, so right offset is left offset, etc.
    result.push({ x: dropZoneOffset, y: lineHeight / 2 }); // 0

    for (let i = 1; i <= 12; i++) {
      let space = 0;
      if (i > 6) {
        space = 0.97;
      }
      currentX = (i - 1 + space) * stepX + offsetFromRight + stepX / 30;
      currentY = topLinesY;
      result.push({ x: currentX, y: currentY });
    }

    for (let i = 13; i < 25; i++) {
      let space = 0;
      if (i > 18) {
        space = 0.96;
      }

      currentX = canvasWidth - offsetFromLeft - (i - 12 + space) * stepX + stepX / 2;
      currentY = bottomLinesY;
      result.push({ x: currentX, y: currentY });
    }

    result.push({ x: dropZoneOffset, y: height - lineHeight / 2 }); //25
    result.push({
      x: (canvasWidth - offsetFromLeft) / 2 + offsetFromRight / 2,
      y: topLinesY * 1.6,
    }); // 26
    result.push({
      x: (canvasWidth - offsetFromLeft) / 2 + offsetFromRight / 2,
      y: height - topLinesY * 1.6,
    }); // 27
  } else if (myColor === Color.Black && !myHomeIsOnLeftPref) {
    result.push({ x: canvasWidth - dropZoneOffset, y: lineHeight / 2 }); // 0

    for (let i = 1; i <= 12; i++) {
      let space = 0;
      if (i > 6) {
        space = 0.97;
      }
      currentX = canvasWidth - offsetFromRight - (i + space) * stepX + stepX / 2.3;
      currentY = topLinesY;
      result.push({ x: currentX, y: currentY });
    }

    for (let i = 13; i < 25; i++) {
      let space = 0;
      if (i > 18) {
        space = 0.96;
      }
      currentX = (i - 13 + space) * stepX + offsetFromLeft + stepX / 2.1;
      currentY = bottomLinesY;
      result.push({ x: currentX, y: currentY });
    }

    result.push({
      x: canvasWidth - dropZoneOffset,
      y: height - lineHeight / 2,
    }); //25
    result.push({
      x: (canvasWidth - offsetFromRight) / 2 + offsetFromLeft / 2,
      y: topLinesY * 1.6,
    }); // 26
    result.push({
      x: (canvasWidth - offsetFromRight) / 2 + offsetFromLeft / 2,
      y: height - topLinesY * 1.6,
    }); // 27
  }

  for (let i = 0; i < result.length; i++) {
    result[i].y += offsetFromTop;
  }

  return result;
}
